<template>
  <v-dialog v-model="open" persistent max-width="800px">
    <material-card color="primary" :title="title" :text="item.name">
      <v-form ref="form"  autocomplete="off" role="presentation" v-model="validForm">

        <safety-cin-modal v-model="chooseInitial" :title="chooseInitialTitle" :initialsList="initialsList" :choosed.sync="choosedInitial" />

        <v-container grid-list-md>
          <v-layout wrap>

            <v-flex xs12 sm4 md4>
              <v-text-field
                label="Case Identification Number"
                v-model="cin"
                disabled
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm4 md4>
              <v-select
                clearable
                md4
                v-model="selectedProtocol"
                :items="protocols"
                label="Protocol"
                :rules="validators.sae.protocol"
                item-value="id"
                item-text="name"
                :disabled="!isNew"
                return-object
                @change="searchCenter();calculateCin();"
              ></v-select>
            </v-flex>

            <v-flex xs12 sm4 md4>
              <v-text-field
                label="Patient"
                :disabled="!isNew"
                v-model="item.patient_id"
                :rules="validators.sae.patient"
                @input="searchCenter()"
                @change="calculateCin()"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm8 md8>
               <v-autocomplete
                md4
                clearable
                :search-input.sync="siteSearchString"
                v-model="selectedSite"
                :items="sites"
                color="green"
                hide-no-data
                item-text="name"
                item-value="id"
                label="Site Name"
                :rules="validators.sae.site"
                placeholder="Choose from Sites..."
                prepend-icon="mdi-database-search"
                :loading="loadingSites"
                :disabled="!item.protocol_id"
                return-object
                @change="calculateCin()"
              >
                <template slot="item" slot-scope="{ item }" >
                  <v-list-tile-content>
                      <v-list-tile-title>{{item.name}}</v-list-tile-title>
                      <v-list-tile-sub-title>{{item.country}}</v-list-tile-sub-title>
                    </v-list-tile-content>
                </template>
              </v-autocomplete>
            </v-flex>

            <v-flex xs12 sm4 md4>
              <v-menu
                v-model="menu_datePicker_receipt_date"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template slot="activator">
                  <v-text-field
                    clearable
                    v-model="item.receipt_date"
                    label="Receipt Date" 
                    readonly
                    :rules="validators.sae.receipt_date"
                  ></v-text-field>
                </template>
                <v-date-picker dark v-model="item.receipt_date" no-title @input="menu_datePicker_receipt_date = false"></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs12 sm4 md4>
              <v-select
                clearable
                label="Case Type"
                v-model="item.case_type"
                :rules="validators.sae.case_type"
                :items="['Initial', 'Follow up', 'Final']"
                @change="calculateCin()"
              ></v-select>
            </v-flex>

            <v-flex xs12 sm4 md4>
              <v-text-field
                label="AE Verbatim Reported"
                :disabled="!isNew"
                v-model="item.ae_verbatim_reported"
                :rules="validators.sae.ae_verbatim_reported"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm4 md4>
              <v-menu
                v-model="menu_datePicker_onset_date"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template slot="activator">
                  <v-text-field
                    clearable
                    v-model="item.ae_onset_date"
                    label="AE Onset Date" 
                    readonly
                    :rules="validators.sae.onset_date"
                    @change="calculateCin()"
                  ></v-text-field>
                </template>
                <v-date-picker 
                  dark v-model="item.ae_onset_date" 
                  no-title 
                  @input="menu_datePicker_onset_date = false"
                  @change="calculateCin()"
                  ></v-date-picker>
              </v-menu>
            </v-flex>


            <v-flex xs12 sm12 md12>
              <v-combobox
                clearable
                md4
                multiple
                chips
                v-model="item.serious_criteria"
                :items="seriousCriterias"
                :rules="validators.sae.serious_criteria"
                label="Serious Criteria"
                :disabled="!isNew"
              ></v-combobox>
            </v-flex>

            
          </v-layout>
        </v-container>
      </v-form>

      <v-flex xs12 text-xs-right>
        <v-btn class="mx-1 font-weight-light" color="success" @click="close()"
          >Close</v-btn
        >

        <v-btn
          class="mx-1 font-weight-light"
          color="purple"
          :disabled="!validForm"
          @click="save()"
          v-if="$can('upsert', 'adverse_event')"
          >Save</v-btn
        >
      </v-flex>
    </material-card>

    <v-dialog v-model="anotherInitial" persistent max-width="800px">
      <material-card color="primary" title="Another SAE for the same AE Onset Date and Patient. Are you Sure?">
        <v-form ref="form">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
               
                 <v-data-table
                  :items="[anotherInitialSae]"
                  hide-actions
                >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th class="text-xs-left">Cin</th>
                    <th class="text-xs-left">Onset Date</th>
                    <th class="text-xs-left">Receipt Date</th>
                    <th class="text-xs-left">Verbatim reported</th>
                  </tr>
                </template>
                <template slot="items" slot-scope="{ item }" >
                  <td class="text-xs-left"><b>{{ item.cin }}</b></td>
                  <td class="text-xs-left">{{ item.ae_onset_date }}</td>
                  <td class="text-xs-left">{{ item.receipt_date }}</td>
                  <td class="text-xs-left">{{ item.ae_verbatim_reported }}</td>
                </template>
              </v-data-table>

              </v-flex>
            </v-layout>
          </v-container>
        </v-form>

        <v-flex xs12 text-xs-right>
          <v-btn class="mx-1 font-weight-light" color="success" @click="anotherInitial = false">Close</v-btn>

           <v-btn
            class="mx-1 font-weight-light"
            color="pink"
            @click="choosedInitial = anotherInitialSae_nextCin; anotherInitial = false;">Confirm</v-btn>

        </v-flex>

      </material-card>
    </v-dialog>


  </v-dialog>
</template>

<script>
import { getList as getAEList, upsert, getDetail, getSeriousCriterias, nextCin } from "@/api/adverse_event";
import validators from "@/utils/validators";
import { getList as getSites } from "@/api/site";
import { getList as getProtocolSites } from "@/api/protocol_site";


export default {
  inheritAttrs: false,
  data() {
    return {
      item: {},
      validForm: true,
      validators,
      menu_datePicker_date_of_death: false,
      menu_datePicker_receipt_date: false,
      menu_datePicker_onset_date: false,
      loadingSites: false,
      siteSearchString: '',
      sites: [],
      selectedSite: null,
      selectedProtocol: null,
      cin: null,
      chooseInitial: false,
      chooseInitialTitle: '',
      initialsList: [],
      choosedInitial: null,
      anotherInitial: false,
      anotherInitialSae: {},
      anotherInitialSae_nextCin: null,
    };
  },
  mounted() {
    this.item.serious = 1;
  },
  watch: {
    open(val) {
      this.$refs.form.resetValidation();
      this.$refs.form.reset();
      this.cin = null;
      this.selectedSite = null;
      this.selectedProtocol = null;
      this.item = {};
    },
    siteSearchString(val, oldVal) {
        if (!val) {
          this.sites = [];
          return;
        }
        this.loadingSites = true
        getProtocolSites({ "site.name":  "%" + val + "%", "protocol_id":this.item.protocol_id }, { rowsPerPage: null }).then(data => {
          const sites = data.data.map(el => {
            return el['site'];
          });
          this.sites = sites;
          this.loadingSites = false;
        });

    },
    selectedSite(v) {
      if (v) {
        this.item.site_id = v.id;
      }
    },
    selectedProtocol(v) {
      if (v) {
        this.item.protocol_id = v.id;
        this.sites = [];
        this.selectedSite = null;
      } else {
        this.sites = [];
        this.selectedSite = null;
        this.item.site_id = null;
        this.item.protocol_id = null;
      }
    },
    choosedInitial(v) {
      this.cin = v;
      this.item.cin = v;
    },
    cin(v) {
      if (v) {
        this.item.cin = v;
      }
    }
  },
  asyncComputed: {
  },
  computed: {
    open() {
      return this.$store.getters.adverseEventMandatoryDialog;
    },
    protocols() {
      return this.$store.getters.protocols;
    },
    isNew() {
      return this.item.id ? false : true;
    },
    title() {
      return this.isNew ? "New Adverse Event" : "Edit Adverse Event";
    },
    seriousCriterias() {
      return getSeriousCriterias();
    }
  },
  methods: {
    close() {
      this.$store.dispatch("app/closeAdverseEventMandatoryDialog");
    },
    save() {
      if (!this.$refs.form.validate()) {
        this.$store.dispatch("app/openSnackbar", {
          message: "Please fix validation errors!",
          color: "error"
        });
        return;
      }

      this.item.is_read = 0;

      upsert(this.item)
        .then(data => {
          this.$store.dispatch("app/openSnackbar", {
            message: "Adverse Event updated correctly",
            color: "success"
          });
          const newItem = JSON.parse(JSON.stringify(data.data));
          // this.$store.commit("app/adverseEventItem", newItem);
          this.$root.$emit('updateAdverseEvents', newItem);
          this.$store.dispatch("app/closeAdverseEventMandatoryDialog");
        })
        .catch(e => {
          this.$store.dispatch("app/openSnackbar", {
            message:
              "An Error occurred during the Adverse Event update. " +
              e.response.data.message,
            color: "error"
          });
        });
    },
    calculateCin() {
      
      this.choosedInitial = null;
      if (
          this.selectedSite &&
          this.selectedProtocol &&
          this.item.site_id &&
          this.item.patient_id &&
          this.item.ae_onset_date &&
          this.item.case_type
      ) {

        const nextCinData = {
          country_code: this.selectedSite.country_code,
          protocol_id: this.selectedProtocol.id,
          patient_id: this.item.patient_id,
          case_type: this.item.case_type,
          ae_onset_date: this.item.ae_onset_date
        };

        return nextCin(nextCinData).then( (data) => {
          this.cin = this.item.cin = data.nextCIN;
          return data.nextCIN;
        }).catch( e => {
          
          this.cin = this.item.cin = null;
          
          const errorData = e.response.data;

          // choose initial for this follow up
          if (errorData.error_details && errorData.error_details.errorCode == 'multiple_initials') {
            this.initialsList = errorData.error_details.initials;
            this.chooseInitialTitle =  "Multiple Initial case found for this SAE";
            this.chooseInitial = true;
            return null;
          }

            // confirm double initial for the same date
          if (errorData.error_details && errorData.error_details.errorCode == 'another_initial') {
            this.anotherInitialSae = errorData.error_details.initial;
            this.anotherInitialSae_nextCin = errorData.error_details.nextCin;
            this.anotherInitial = true;
            return null;
          }

            // no initial found...possibly onset date error
          if (errorData.error_details && errorData.error_details.errorCode == 'no_initial' && errorData.error_details.initials.length) {
            this.initialsList = errorData.error_details.initials;
            this.chooseInitialTitle =  "No Initial case found for this SAE. OnSet Date is changed?";
            this.chooseInitial = true;
            return null;
          }

          
          this.$store.dispatch("app/openSnackbar", {
            message: "CIN error, please check data : " +  errorData.message,
            color: "error"
          });
          return null

        });
      } else {
        this.cin =  this.isNew ? null : this.item.cin;
      }

    },
    searchCenter() {
      if (this.selectedProtocol && this.item.patient_id) {
        getAEList({protocol_id: this.selectedProtocol.id, patient_id: this.item.patient_id}, {rowsPerPage: null}).then( data => {
          if(data.tot > 0) {
            this.sites = [data.data[0].site];
            this.selectedSite = data.data[0].site;
          } else {
            this.selectedSite = {}
          }
        });
      }
    }
  }
};
</script>

<style>
#core-view {
  padding-bottom: 100px;
}

.theme--light.v-label {
  font-size: 14px;
  color: #aaa;
  font-weight: 400;
}

</style>
